/* eslint-disable no-unused-vars */
import React from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/aunjai-selectloan.css";
import LoanProductCard from "../../components/card/LoanProductCard";
import LoadingPage from "../../components/LoadingPage/LoadingPage";
import { useFetchLoans } from "../../hooks/fetch-data/useFetchLoans";
import { useUser } from "../../hooks/useUser";
import { useLoanStore } from "../../stores/useLoanStore";
import { getLoansMatchingUserCriteria } from "../../utils/loan";
import Header from "../Header/HeaderComponent";
import HeaderDesktop from "../Header/HeaderDesktop";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";


const SelectLoan = () => {
  const { data: loans, isFetching: isFetchingLoans } = useFetchLoans();
  const { t } = useTranslation('selectLoan');
  const incomeFormProfile = useLoanStore((state) => state.incomeFormProfile);

  const { userData } = useUser();

  const navigate = useNavigate();

  const eligibleLoans = getLoansMatchingUserCriteria(
    loans,
    incomeFormProfile,
    userData
  );

  const isDesktop = useIsDesktop();

  if (isFetchingLoans)
    return <LoadingPage message={t('loandingSelectLoan')} />;

  return (
    <div id="PageSelectLoan">
      {isDesktop ? (
          <HeaderDesktop title={t('selectLoan')} showIcon={true} onBack={() => navigate("/")} />
        ) : (
          <Header title={t('selectLoan')}showIcon={true} onBack={() => navigate("/")}/>
        )}
      <div className="wrapContent">
        <div id="pSelectLoan">
          <div className="bSelectLoan">
            <div className="bContent">
              <div className="bSelectContent">
                <div className="bContentBottom">
                  <div className="bText">
                    <h3>{t('loanForYou')}</h3>
                    <p>{t('selectedLoan')} </p>
                  </div>
                  <div className="bCardContainer">
                    {eligibleLoans?.map((loan) => (
                      <LoanProductCard key={loan.id} loan={loan} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectLoan;
